import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DetailPair } from './DetailPair';

@Component({
  selector: 'app-detail-info-card',
  templateUrl: './detail-info-card.component.html',
  styleUrls: ['./detail-info-card.component.scss'],
  standalone: true,
  imports: [
    MatCardModule,
    MatIcon,
    CommonModule,
    MatTooltipModule
  ]
})
export class DetailInfoCardComponent implements OnInit {

  @Input() title!: string;
  @Input() data!: DetailPair[];
  @Input() fullRowData!: DetailPair;
  @Input() disableShadow: boolean = false;
  @Output() editEvent = new EventEmitter();

  constructor(private router: Router) {}

  ngOnInit() { }

  onEditClick(): void {
    this.editEvent.emit();
  }

  goToRoute(data: any) {
    this.router.navigate([ data.idOptions?.route ]);
  }
}